<template>
  <div id="app">
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive">
        <!-- 这里是会被缓存的视图组件，比如 Home！ -->
      </router-view>
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive"></router-view>
  </div>
</template>

<script>
import './assets/css/reset.css'
import '@/assets/font/font.css'
// document.oncontextmenu = new Function("event.returnValue=false");
// document.onselectstart = new Function("event.returnValue=false");

export default {
  name: 'App',
}
</script>

<style>
#app {}
</style>



// WEBPACK FOOTER //
// src/App.vue